import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'react-bootstrap';

import FieldGroupComponent from '../../core/FieldGroupComponent/FieldGroupComponent';

import './update-profile.scss';
import LoadingComponent from '../../core/LoadingComponent/LoadingComponent';

class UpdateEmailComponent extends React.Component {
    render() {
        const { handleSubmit, invalid, submitting } = this.props;

        return <div>
            {submitting && <LoadingComponent fullscreen />}
            <Form onSubmit={handleSubmit}>
                <FieldGroupComponent
                    label="Email"
                    name="email"
                    type="text"
                    formProps={{
                        maxLength: 30,
                    }}
                />
                <FieldGroupComponent
                    label="Password"
                    name="password"
                    type="password"
                    formProps={{
                        maxLength: 30,
                    }}
                />
                <Button disabled={invalid} type="submit" className="tertiary">Update</Button>
            </Form>
        </div>;
    }
}

UpdateEmailComponent.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
};

export default UpdateEmailComponent;



// WEBPACK FOOTER //
// ./src/components/profile/Profile/UpdateEmailComponent.js